module.exports = __webpack_public_path__ + "static/img/background2.77fc30d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background2.png
// module id = Mzsl
// module chunks = 1